import styles from '@/layouts/MenuSide/index.module.less'
import { MenuCollapseArrow } from '@/components/icons.tsx'
import MenuItem from '@/layouts/MenuSide/MenuItem.tsx'

const MenuCollapseBtn = props => {
  const collapsed = props.collapsed
  return (
    <MenuItem
      className={styles.collapseBtn}
      onClick={props.onClick}
      styles={{
        icon: Object.assign(
          {
            fontSize: 12,
            padding: 6,
            color: 'rgba(255, 255, 255, 1)',
          },
          collapsed ? { transform: 'rotate(180deg)' } : null,
        ),
        text: {
          fontSize: 12,
        },
      }}
      icon={<MenuCollapseArrow />}
      collapsed={collapsed}
      title="展开侧边栏"
    >
      折叠侧边栏
    </MenuItem>
  )
}

export default MenuCollapseBtn
